export default "__VITE_ASSET__CfNy06Zm__"